export default function GovernanceProcess() {
  return (
    <section
    id="governance"
      className="w-screen flex flex-col items-center justify-center pb-10"
      style={{
        background:
          "linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0) 90%), " +
          "linear-gradient(180deg, rgba(103,119,255,0.09) 10%, rgba(195,131,251,0.09) 100%)"
      }}
    >
      <h2 className="font-medium text-5xl text-[#121828] mb-6 text-center">Governance Process</h2>
      <p className="text-base text-[#414653] max-w-6xl text-center mb-6 px-4">
        XAO DAO’s governance process is designed to be fair, transparent, and inclusive. All members have voting rights, but to maintain balance, there are caps on the maximum number of votes that can be exercised by a single wallet or individual, regardless of token holdings. This ensures that no single entity can dominate decision-making, while still rewarding active participation.<br />
        The governance process applies to key areas such as treasury management, grant approvals, rule amendments, and the overall strategic direction of XAO DAO.
      </p>
      <h3 className="font-semibold text-2xl text-[#121828] mb-8 text-center">The process works as follows:</h3>
      <div className="flex flex-col w-full max-w-6xl gap-12 px-4">
        {/* Proposal Submission */}
        <div className="flex flex-col md:flex-row items-center justify-center py-8 gap-8 md:gap-16">
          <div className="flex flex-col items-center min-w-[220px] text-center">
            <div className="relative w-20 h-20 flex items-center justify-center mb-4">
              <img src="./proposalIcon.png" alt="Step 1" className="w-8 h-8 md:w-auto md:h-auto" />
            </div>
            <h4 className="font-semibold text-2xl text-[#121828] mb-2">Proposal Submission</h4>
            <p className="text-[#414653] text-base">Any member may submit a proposal.</p>
          </div>
          <div className="relative w-full max-w-xs flex items-center justify-center" style={{ minWidth: '260px' }}>
            <img src="/govProposal.png" alt="Gov Proposal" className="absolute left-[-20px] top-4 w-44 opacity-80 -z-10 md:block hidden" style={{ zIndex: 0 }} />
            <img src="/govProposalTop.png" alt="Proposal Submission" className="rounded-xl w-full max-w-[250px] relative z-10 ml-0 md:ml-4" />
          </div>
        </div>
        {/* Community Review */}
        <div className="flex flex-col md:flex-row-reverse items-center justify-center py-8 gap-8 md:gap-16">
          <div className="flex flex-col items-center min-w-[220px] text-center">
            <div className="bg-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center mb-4">
              <img src="./communityIcon.png" alt="Step 2" className="w-8 h-8" />
            </div>
            <h4 className="font-semibold text-2xl text-[#121828] mb-2">Community Review</h4>
            <p className="text-[#414653] text-base max-w-lg">Proposals are discussed openly, allowing feedback, suggestions, and debate.</p>
          </div>
          <img src="./communityReview.png" alt="Community Review" className="rounded-xl w-full max-w-lg mr-0 md:mr-8" />
        </div>
        {/* Voting */}
        <div className="flex flex-col md:flex-row items-center justify-center py-8 gap-8 md:gap-16">
          <div className="flex flex-col items-center min-w-[220px] text-center">
            <div className="bg-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center mb-4">
              <img src="./votingIcon.png" alt="Step 3" className="w-8 h-8" />
            </div>
            <h4 className="font-semibold text-2xl text-[#121828] mb-2">Voting</h4>
            <p className="text-[#414653] text-base max-w-lg">Once finalized, proposals move to a vote. Each member’s vote is weighted within the capped system.</p>
          </div>
          <img src="/voting.png" alt="Voting" className="rounded-xl w-full max-w-lg mr-0 md:mr-8" />
        </div>
        {/* Implementation */}
        <div className="flex flex-col md:flex-row-reverse items-center justify-center py-8 gap-8 md:gap-16 mb-10">
          <div className="flex flex-col items-center min-w-[220px] text-center">
            <div className="bg-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center mb-4">
              <img src="./implementationIcon.png" alt="Step 4" className="w-8 h-8" />
            </div>
            <h4 className="font-semibold text-2xl text-[#121828] mb-2">Implementation</h4>
            <p className="text-[#414653] text-base max-w-lg">Successful proposals are executed transparently, with updates shared publicly.</p>
          </div>
          <img src="./implementation.png" alt="Implementation" className="rounded-xl w-full max-w-lg mr-0 md:mr-8" />
        </div>
      </div>
    </section>
  );
}